import React from "react";
import ReportManager, {
  linesColumns,
  linesTransformer,
} from "commons/components/ReportManager";

const filters = [
  { type: "filter", name: "products", key: "product_id" },
  { type: "filter", name: "facilities", key: "purchases.facility_id" },
  {
    type: "filter",
    name: "users",
    key: "purchases.user_id",
    extras: { optionLabel: "username" },
  },
  { type: "filter", name: "suppliers", key: "purchases.supplier_id" },
];

const columns = [
  {
    name: "code",
    type: "text",
  },
  {
    name: "name",
    type: "text",
  },
  ...linesColumns,
];

const byProductID = (record) => record.product_id + "";

export default function PurchasesByProduct() {
  return (
    <ReportManager
      filterByDate
      dateField="purchases.date"
      url="purchase-lines"
      title="purchasesByProduct"
      filters={filters}
      columns={columns}
      recordsFunc={linesTransformer(byProductID, "product_id")}
      totals={[
        "quantity",
        "subtotal",
        "discount",
        "total",
        "cost",
        "commission",
      ]}
    />
  );
}
